/**************************************************
 * Nombre:       Seccion_Catalogo
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {Apartment} from '@mui/icons-material'
import {theme} from "../../Tema";
import Tarjeta_Productos from "../Tarjetas/Tarjeta_Productos";
import {useContext, useEffect, useState} from "react";
import {contexData} from "../../App";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {useVerWidth} from "../../Utilidades/useVerWidth";
import img_def from '../../Recursos/img_cat_defecto.png'
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {Splide, SplideSlide} from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import Portada_Home from "../Componentes/Home/Portada_Home";
import Caracteristicas_Home from "../Componentes/Home/Caracteristicas_Home";
import Marcas_Home from "../Componentes/Home/Marcas_Home";
import Preguntas_Home from "../Componentes/Home/Preguntas_Home";
import Creamos_Home from "../Componentes/Home/Creamos_Home";
import Footer from "../Footer";
import Puntos_Home from "../Componentes/Home/Puntos_Home";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Ofertas = () => {
    const cData = useContext(contexData)
    const {sCell} = useResponsive()
    const {ancho} = useVerWidth()
    const [productos, setProductos] = useState([])

    useEffect(() => {

        irArriba()
        obtenerColWheres({col: 'productos', wheres: [where('oferta', '==', 'Si')]}).then((dox) => {
            setProductos(dox.data)
        })

    }, []);


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 3}}

        >

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    direction={'row-reverse'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>


                    <Grid container size={{xs: 12, sm: 6, md: 6}}
                          sx={{justifyContent: sCell ? 'center' : 'flex-end'}}
                    >
                        {cData.rutas.length > 0 &&

                            <Splide
                                aria-label="My Favorite Images"
                                options={{
                                    arrows: false,
                                    pagination: false,
                                    autoplay: true,
                                    interval: 5000,
                                    width: '100%',
                                    perPage: 1,  // 3 items per page for larger screens
                                    perMove: 1,
                                    type: 'loop',
                                    gap: '1rem',  // Ajuste del espacio entre los elementos

                                }}
                            >
                                {cData.rutas.map((ruta, index) => (
                                    <SplideSlide key={index}>
                                        <Grid
                                            container
                                            justifyContent={sCell ? 'center' : 'flex-end'}
                                            alignItems={'flex-start'}
                                            size={{xs: 12, sm: 12, md: 12}}>

                                            <Typography
                                                sx={{
                                                    color: theme.palette.primary.main,
                                                    mt: -0.2,
                                                    textAlign: sCell ? 'center' : 'rigth',
                                                    lineHeight: 1.1
                                                }}
                                            >
                                                <span><Apartment sx={{mt: -1, mb: -0.6}}/></span>
                                                <span style={{
                                                    fontWeight: 600,
                                                    paddingLeft: 5,
                                                    paddingRight: 5
                                                }}>{`${ruta.ciudad}: `}</span>
                                                {ruta.descripcion}
                                            </Typography>

                                        </Grid>

                                    </SplideSlide>
                                ))}
                            </Splide>
                        }

                    </Grid>

                    <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{mt: sCell ? 2 : 0}}>
                        <Typography sx={{fontSize: 20, fontWeight: 600, color: '#4C4C4C'}}>
                    <span><img src={cData.iconoCat ? cData.iconoCat : img_def} width={30}
                               height={'auto'}
                               style={{marginBottom: -6, marginRight: 6}}/></span>
                            Ofertas</Typography>
                    </Grid>


                </Grid>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 3, justifyContent: 'center'}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={3}
                >


                    {productos.map((it, index) => {
                        return (
                            <Grid container size={{xs: 12, sm: 4, md: ancho > 1350 ? 3 : 4}}>
                                <Tarjeta_Productos item={it}/>
                            </Grid>
                        )
                    })}

                </Grid>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: productos[0] ? 6 : 0}}>
                <Portada_Home/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: -4}}>
                <Caracteristicas_Home/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 6}}>
                <Marcas_Home/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 18}}>
                <Preguntas_Home/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 18}}>
                <Puntos_Home/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 18}}>
                <Creamos_Home/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 18}}>
                <Footer/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Ofertas


